import { createSelector } from 'reselect';

export const getConfigurations = createSelector(
  state => state.garage.configurations,
  configurations => configurations
);

export const getLoadedConfiguration = createSelector(
  state => state.garage.loadedConfiguration,
  loadedConfiguration => loadedConfiguration
);

export const getSaving = createSelector(
  state => state.garage.saving,
  saving => saving
);
